import { Authentication } from "../authentication";
import { StoredAuthentication } from "../stored-authentication";

/**
 * Defines members for mapping from a stored authentication to an authentication.
 */
export abstract class MapStoredAuthenticationToAuthentication {
	/**
	 * Maps the specified stored authentication into an authentication.
	 * @param authentication The stored authentication to map into an authentication.
	 * @returns A new instance of the authentication.
	 */
	public static Map(authentication: StoredAuthentication): Authentication {
		return {
			IsAuthenticated: authentication.IsAuthenticated,
			IsLockedOut: authentication.IsLockedOut,
			UserName: authentication.UserName,
			Email: authentication.Email
		};
	}
}